const bubble1 = (color) => `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 25.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 444.7 444.7" style="enable-background:new 0 0 444.7 444.7;" xml:space="preserve">
<style type="text/css">
\t.st0{fill:${color};}
\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
</style>
<path class="st0" d="M222.4,0C99.6,0,0,99.5,0,222.3s99.5,222.3,222.3,222.3s222.4-99.6,222.4-222.3S345.2,0,222.4,0z M194.9,284.8
\tL71.2,342.6l27.7-59.4c-25.2-6.2-43.5-29.7-43.5-56.9v-66.9c0-32.3,25.5-58.5,56.8-58.5h148.7c31.3,0,56.8,26.2,56.8,58.5v66.9
\tc0,32.3-25.5,58.5-56.8,58.5H194.9z M359.9,307.3l14.8,35.1l-67.3-34.8h-39.8c-11.6,0-21.8-7.3-27.1-18.1h29.4
\tc28.7,0,52.3-24.2,52.3-53.9v-42.7h33.8c17.1,0,31.1,15.9,31.1,35.4v43.9C387,290.1,375.1,305.1,359.9,307.3L359.9,307.3z"/>
<ellipse class="st0" cx="229.5" cy="231" rx="207.8" ry="197.1"/>
<path class="st1" d="M230.6,240.5l-0.5-3.1C230.1,238.5,230.3,239.5,230.6,240.5 M117.5,320.2l36.5-7l4.1,25.2l19.2-29.6l21.7-4.1
\tc9.9-2,18.8-7.6,24.8-15.8c-3.6-1.9-7.1-4.1-10.2-6.8c-4.2,5.2-10.1,8.7-16.6,10l-81.5,15.5c-16,3.1-31.4-8.6-34.2-25.9l-14.4-88.2
\tc-2.8-17.3,8-34,24-37l81.5-15.5c13.5-2.6,26.6,5.4,32.1,18.3l2.9-17.8c-9.2-10.4-23-15.8-37-13.1l-81.5,15.5
\tc-22.4,4.3-37.5,27.6-33.6,51.9l14.4,88.2C73.5,308.1,95.1,324.4,117.5,320.2z"/>
<path class="st1" d="M153.5,283c-29.9,5.7-58.5-15.9-63.9-48.2c0-0.1,0-0.1,0-0.2l0,0c-0.7-4.3,1.9-8.3,5.9-9.1s7.7,2.1,8.4,6.4l0,0
\tc3.9,23.9,25,39.9,47.1,35.7c22.1-4.2,36.9-27.1,33-51l0,0c-0.7-4.3,1.9-8.3,5.9-9.1s7.7,2.1,8.4,6.4l0,0
\tC203.5,246.3,183.5,277.3,153.5,283"/>
<path class="st1" d="M227.7,230.3L227.7,230.3c-2.8,17.4,8,34.1,24,37.1l81.5,15.5c16,3.1,31.4-8.6,34.2-25.9l14.4-88.2
\tc2.8-17.3-8-34-24-37l-81.5-15.5c-16-3-31.4,8.6-34.2,25.9v0.1L227.7,230.3z M331.1,295.5l-36.5-7l-4.1,25.2l-19.2-29.6l-21.7-4.1
\tc-22.4-4.3-37.5-27.6-33.6-51.9l3.1-19.2l8.1-49.7l3.1-19.1V140c4-24.2,25.5-40.6,47.9-36.3l81.5,15.5c22.4,4.3,37.5,27.6,33.6,51.9
\tL379,259.2C375.1,283.5,353.5,299.8,331.1,295.5z"/>
<path class="st1" d="M295.2,258.4c29.9,5.7,58.5-15.9,63.9-48.2V210l0,0c0.7-4.3-1.9-8.3-5.9-9.1s-7.7,2.1-8.4,6.4l0,0
\tc-3.9,23.9-25,39.9-47.1,35.7s-36.9-27.1-33-51l0,0c0.7-4.3-1.9-8.3-5.9-9.1c-4-0.6-7.7,2.1-8.3,6.1c0,0.1,0,0.2,0,0.3l0,0
\tC245.1,221.7,265.1,252.6,295.2,258.4"/>
</svg>
`;
export default bubble1;


//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble1.js
// module id = null
// module chunks = 